import { FeatureFlag } from '@core/typings/feature-flag.typing';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class FeatureFlagsState extends BaseYcState {
  featureFlags: FeatureFlag[];
}
